import { useMemo }             from 'react';
import { colors }              from 'utils/colors';
import logo                    from 'images/yisumaticaLogo.png';
import MenuRoundedIcon         from '@mui/icons-material/MenuRounded';
import CloseRoundedIcon        from '@mui/icons-material/CloseRounded';
import { componentsStateType } from 'reducer/types';
import { makeStyles }           from 'makeStyles';

const useStyles = makeStyles()(() => ({
    icon_container: {
      position:        'absolute',
      right:           0,
      width:           '15vw',
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
      cursor:          'pointer',
    },
    icon: {
      color:    colors.darkText,
      fontSize: 28
    },
    logoContainer: {
      position:       'absolute',
      right:          0,
      width:          '15vw',
    //  height:         100,
      display:        'flex',
      alignItems:     'center',
      justifyContent: 'flex-end',
    },
    logo: {
      width:              '85%',
      height:             50,
      backgroundImage:    `url(${ logo })`,
      backgroundPosition: 'left',
      backgroundSize:     'contain',
      backgroundRepeat:   'no-repeat',
    },
   
}))

type ButtonOrLogoProps = {
  componentsState: componentsStateType;
  page:            string;
  wideScreen:      boolean;
  logoStyle:       { [key: string]: any; }
}

const ButtonOrLogo: React.FC<ButtonOrLogoProps> = ({ 
  componentsState,
  page,
  wideScreen,
  logoStyle
}) => {

  const { classes } = useStyles();

  const showMenuButton = useMemo(() => {
    return !wideScreen && (page === 'content' || page === 'teacherContent' || page === 'puzzles')
  },[wideScreen, page])


  return (
    <>
      {
          showMenuButton
          &&
          <div 
               className = { classes.icon_container }
               style     = { logoStyle }
               onClick   = {() => {
                import("functions/navbar/handle_menu_toggle").then(func => {
                  func.handleMenuToggle() 
                });
               }}
          >
              {
                componentsState.showSmallMenu ? <CloseRoundedIcon className = { classes.icon }/> : <MenuRoundedIcon className = { classes.icon }/>
              }
          </div>
      }
      {
          !showMenuButton 
          && 
          <div 
             className = { classes.logoContainer }
             style     = { logoStyle }
          >
             <div className = { classes.logo }/>
          </div>
      }
    </>
  );
}


export default ButtonOrLogo



